import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class NotificationsService {
  constructor(private readonly http: HttpClient) {}

  getAllNotifications() {
    return this.http.get(`notifications/filtered-list/`);
  }

  getAllReadNotifications(id: any, section: any) {
    return this.http.post(
      `notifications/${id}/mark-as-read/`,
      { filters: { status: "unread", section: `${section}` } },
      { observe: "response" }
    );
  }

  updateNotificationState(id:any, payload: any){
    return this.http.post(
      `notifications/${id}/update-notification-state/`,
      payload,
    );
  }

  // Home page notificaitons APIs

  getNotificationsByPage(pageKey: any) {
    return this.http.get(
      `notifications/filtered-list/?status=unread&section=${pageKey}`
    );
  }

  getChatBotQueryList(queryName: any) {
    return this.http.get(
      `${environment.airoFrontendURL}/server/api/cache/?query=${queryName}`
    );
  }
}
